import { Component, Input, OnInit } from '@angular/core';
import { TransportOption, TransportOptionSelection, TransportOptionsPanelModel, TransportOptionsPanelModelUsage } from '../../transport-options-panel.model';
import { TranslationService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';



@Component({
  selector: 'app-transport-option-entry',
  templateUrl: './transport-option-entry.component.html',
  styleUrls: ['./transport-option-entry.component.scss']
})
export class TransportOptionEntryComponent implements OnInit {

  loadingEnabled = true;

  @Input() option: TransportOption;

  @Input() model: TransportOptionsPanelModel;

  @Input() showInternalTransportOptions = true;

  @Input() showDriverHints = false;

  formGroup = new FormGroup({
    selection: new FormControl(null, []),
    amountOfPallettes: new FormControl(null, []),
    amountOfBoxes: new FormControl(null, []),
    amountInKilogramm: new FormControl(null, []),
    amountInLiter: new FormControl(null, []),
    amountOthers: new FormControl(null, []),
    parameter: new FormControl(null, [])
  });

  selection: TransportOptionSelection;

  constructor(
    public translationService: TranslationService
  ) {

  }

  ngOnInit(): void {

    console.log('model is', this.model);

    if (this.option == null || this.model == null) {
      console.error('component is not well initialized, model and option are not allowed to be null');
      return;
    }

    this.selection = this.getSelection();
    if (this.selection != null && this.selection.selected) {
      this.formGroup.patchValue({
        selection: true,
        amountOfPallettes: this.selection.amountOfPallettes,
        amountOfBoxes: this.selection.amountOfBoxes,
        amountInKilogramm: this.selection.amountInKilogramm,
        amountInLiter: this.selection.amountInLiter,
        amountOthers: this.selection.amountOthers,
        parameter: this.selection.parameterValues
      });
      if (this.selection.fixed) {
        this.formGroup.controls.selection.disable();
      }
    }


    this.formGroup.valueChanges.subscribe(value => {
      // Direkter Zugriff über control, da der Wert in value NULL istt, wenn das Feld deaktiviert ist
      this.selection = this.getOrCreateSelection();
      if (this.formGroup.controls.selection.value) {
        this.selection.selected = true;
      } else {
        this.selection.selected = false;
      }
      this.model.dirty = true;

      this.selection.amountOfPallettes = value.amountOfPallettes;
      this.selection.amountOfBoxes = value.amountOfBoxes;
      this.selection.amountInKilogramm = value.amountInKilogramm;
      this.selection.amountInLiter = value.amountInLiter;
      this.selection.amountOthers = value.amountOthers;
      this.selection.parameterValues = value.parameter;

      this.model.validate();
      this.model.notifySelectionChange();
    });

    // wenn mode = terminal und terminal mandatory or mode = time and timemandtory
    if (this.model.usage === TransportOptionsPanelModelUsage.OTHER ||
      (this.model.usage === TransportOptionsPanelModelUsage.TERMINAL && this.option.amountMandatoryInTerminal) ||
      (this.model.usage === TransportOptionsPanelModelUsage.TIME && this.option.amountMandatoryInTime)) {
      this.loadingEnabled = true;
    } else {
      this.loadingEnabled = false;
    }

  }

  private getSelection(): TransportOptionSelection {
    for (const selection of this.model.selection) {
      if (selection.transportOptionId === this.option.id) {
        return selection;
      }
    }
  }

  private getOrCreateSelection(): TransportOptionSelection {
    let selection = this.getSelection();
    if (selection != null) {
      return selection;
    }
    selection = new TransportOptionSelection({ transportOptionId: this.option.id });
    this.model.selection.push(selection);
    return selection;
  }


}
